// extracted by mini-css-extract-plugin
export var section = "styles-module--section--2y8Fr";
export var title = "styles-module--title--2uwHz";
export var accButton = "styles-module--accButton--2DPD8";
export var accItem = "styles-module--accItem--1C1J_";